import { render, staticRenderFns } from "./CaseCreate.vue?vue&type=template&id=11731cd7&scoped=true&"
import script from "./CaseCreate.vue?vue&type=script&lang=js&"
export * from "./CaseCreate.vue?vue&type=script&lang=js&"
import style0 from "./CaseCreate.vue?vue&type=style&index=0&id=11731cd7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11731cd7",
  null
  
)

export default component.exports